import exportPackage from './export-package.vue';
import importPackage from './import-package.vue';

export default { importPackage, exportPackage };
